var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
    variant: 'info',
    title: 'Show Trasport Info'
  }),expression:"{\n    variant: 'info',\n    title: 'Show Trasport Info'\n  }",modifiers:{"hover":true}}],staticClass:"icon-button",attrs:{"icon":"fas fa-truck-arrow-right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }